var React = require('react');

function Locked (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-3163.73,-406.702)"},React.createElement("g",{"transform":"matrix(1,0,0,1,1724,2.27374e-13)"},React.createElement("g",{"transform":"matrix(1.5,0,0,1.52381,1433.73,405.178)"},React.createElement("path",{"d":"M18,8L17,8L17,6C17,3.24 14.76,1 12,1C9.24,1 7,3.24 7,6L7,8L6,8C4.9,8 4,8.9 4,10L4,20C4,21.1 4.9,22 6,22L18,22C19.1,22 20,21.1 20,20L20,10C20,8.9 19.1,8 18,8ZM12,17C10.9,17 10,16.1 10,15C10,13.9 10.9,13 12,13C13.1,13 14,13.9 14,15C14,16.1 13.1,17 12,17ZM15.1,8L8.9,8L8.9,6C8.9,4.29 10.29,2.9 12,2.9C13.71,2.9 15.1,4.29 15.1,6L15.1,8Z","style":{"fill":"white","fillRule":"nonzero"}})))));
}

Locked.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 32","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Locked;

Locked.default = Locked;
